import { render, staticRenderFns } from "./FCCCompetitionPenalities.vue?vue&type=template&id=89122c4c"
import script from "./FCCCompetitionPenalities.vue?vue&type=script&lang=js"
export * from "./FCCCompetitionPenalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports